import { useResponsive } from '@pflegenavi/web-components';
import type { ReactNode, JSX } from 'react';
import { createContext, useContext, useState, useEffect } from 'react';

export const useCollapseDrawer = (): CollapseDrawerContextProps =>
  useContext(CollapseDrawerContext);
// hooks

// ----------------------------------------------------------------------

export interface CollapseDrawerContextProps {
  isCollapse?: boolean;
  collapseClick: boolean;
  collapseHover: boolean;
  onToggleCollapse: VoidFunction;
  onHoverEnter: VoidFunction;
  onHoverLeave: VoidFunction;
}

const initialState: CollapseDrawerContextProps = {
  collapseClick: false,
  collapseHover: false,
  onToggleCollapse: () => {
    return;
  },
  onHoverEnter: () => {
    return;
  },
  onHoverLeave: () => {
    return;
  },
};

export const CollapseDrawerContext = createContext(initialState);

interface CollapseDrawerProviderProps {
  children: ReactNode;
}

export function CollapseDrawerProvider({
  children,
}: CollapseDrawerProviderProps): JSX.Element {
  const isDesktop = useResponsive('up', 'lg');

  const [collapse, setCollapse] = useState({
    click: false,
    hover: false,
  });

  useEffect(() => {
    if (!isDesktop) {
      setCollapse({
        click: false,
        hover: false,
      });
    }
  }, [isDesktop]);

  const handleToggleCollapse = () => {
    setCollapse({ ...collapse, click: !collapse.click });
  };

  const handleHoverEnter = () => {
    if (collapse.click) {
      setCollapse({ ...collapse, hover: true });
    }
  };

  const handleHoverLeave = () => {
    setCollapse({ ...collapse, hover: false });
  };

  return (
    <CollapseDrawerContext.Provider
      value={{
        isCollapse: collapse.click && !collapse.hover,
        collapseClick: collapse.click,
        collapseHover: collapse.hover,
        onToggleCollapse: handleToggleCollapse,
        onHoverEnter: handleHoverEnter,
        onHoverLeave: handleHoverLeave,
      }}
    >
      {children}
    </CollapseDrawerContext.Provider>
  );
}
